import React from 'react'
import { Dialog } from 'material-ui'

const ModalErr = props => (
  <Dialog
    title="Error occur"
    modal={false}
    open={props.open}
    onRequestClose={props.onClose}
    style={{zIndex: '1501'}}
  >
    {props.err_msg}
  </Dialog>
)

export default ModalErr
